/**
 * Stable CSS class names for E2E — Failed invoice (billing recovery).
 */
export const FINV = {
    page: 'failed-invoice-page',
    mainGrid: 'failed-invoice-page__main-grid',
    filtersSection: 'failed-invoice-page__filters-section',
    filtersInnerGrid: 'failed-invoice-page__filters-inner-grid',
    documentTypeFieldWrap: 'failed-invoice-page__document-type-field',
    inputSelectDocumentType: 'failed-invoice-page-input--select-document-type',
    actionsWrap: 'failed-invoice-page__actions-wrap',
    inputButtonResend: 'failed-invoice-page-input--button-resend',
    gridPaper: 'failed-invoice-page__grid-paper',
    gridInner: 'failed-invoice-page__grid-inner',
    cellLinkShippingId: 'failed-invoice-datagrid-cell--link-shipping-id',
} as const;

export const finvCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
